export async function fetchJson<T = any>(input: string, init: RequestInit = {}): Promise<T> {
	const rawBase = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/+$/, '');
	const API_BASE = rawBase;
	const path = input.startsWith('/') ? input : `/${input}`;
	const url = API_BASE ? `${API_BASE}${path}` : path;
	const method = (init.method || 'GET').toUpperCase();
	const headers = new Headers(init.headers);
	if (!headers.has('Content-Type') && init.body) headers.set('Content-Type', 'application/json');

	// Dev diagnostics: warn if API_BASE points to a likely docker-only hostname not resolvable by the browser
	if (process.env.NODE_ENV !== 'production') {
		try {
			const u = new URL(url, window.location.href);
			const host = u.hostname.toLowerCase();
			const looksDockerInternal = host === 'backend' || host.endsWith('.internal') || host === 'host.docker.internal';
			if (looksDockerInternal && typeof window !== 'undefined') {
				// eslint-disable-next-line no-console
				console.warn('[custportal] REACT_APP_API_BASE_URL appears to be a docker-internal host not reachable from the browser:', u.origin);
			}
			// eslint-disable-next-line no-console
			console.debug('[custportal] fetchJson', { method, url: u.toString(), credentials: init.credentials || 'include' });
		} catch { /* ignore */ }
	}

	const res = await fetch(url, { ...init, headers, credentials: init.credentials || 'include' });
	const text = await res.text();
	let data: any = null;
	try { data = text ? JSON.parse(text) : null; } catch { /* ignore */ }
	if (!res.ok) {
		const err = (data && data.error) || { code: 'HTTP_ERROR', message: res.statusText };
		const e: any = new Error(err.message || res.statusText);
		e.code = err.code; e.details = err.details; e.status = res.status;
		// eslint-disable-next-line no-console
		if (process.env.NODE_ENV !== 'production') console.error('[custportal] fetchJson error', { url, status: res.status, err });
		throw e;
	}
	return data as T;
}

export function getResolvedApiBase(): string {
	const rawBase = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/+$/, '');
	return rawBase || '';
} 